module.exports = __webpack_public_path__ + "media/images/arrow-right-0e9d48290b83964ce04a0f70b42b3816.svg";